/** Default pagination page size */
export const DEFAULT_PAGE_SIZE = 12;

/** Local storage keys */
export const STORAGE_KEYS = {
  CART: 'voltaverde_cart',
  WISHLIST: 'voltaverde_wishlist',
} as const;

/** Sort options for product listing */
export const SORT_OPTIONS = [
  { label: 'Aleatorio', value: 'default' },
  { label: 'Precio: menor a mayor', value: 'price-asc' },
  { label: 'Precio: mayor a menor', value: 'price-desc' },
  { label: 'Mejor valorados', value: 'rating' },
  { label: 'Más recientes', value: 'newest' },
] as const;

/** Navigation links */
export const NAV_LINKS = [
  { label: 'Inicio', href: '/' },
  { label: 'Productos', href: '/products' },
  { label: 'Nosotros', href: '/about' },
  { label: 'Contacto', href: '/contact' },
] as const;
